import { render, staticRenderFns } from "./FormsEditor.vue?vue&type=template&id=7a614f80&scoped=true"
import script from "./FormsEditor.vue?vue&type=script&lang=js"
export * from "./FormsEditor.vue?vue&type=script&lang=js"
import style0 from "./FormsEditor.vue?vue&type=style&index=0&id=7a614f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a614f80",
  null
  
)

export default component.exports